/* eslint-disable */ import { memoEval, sceneEntityRemoteMaterialOverrideComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const volleyballShortsComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'shorts', true).withEntity('VolleyballShorts').attach(memoEval(()=>[], ()=>({
            fileUrl: 'models/volleyball-shorts.glb',
            objectName: 'VolleyballShorts',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'stitches', true).withEntity('VolleyballShorts').attach(memoEval(()=>[], ()=>({
            fileUrl: 'models/volleyball-shorts.glb',
            objectName: 'VolleyballShortsStitches',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'waistband', true).withEntity('VolleyballShorts').attach(memoEval((self)=>[
            self.$waistbandMaterial
        ], ($waistbandMaterial)=>$waistbandMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'leftLeg', true).withEntity('VolleyballShorts').attach(memoEval((self)=>[
            self.$leftLegMaterial
        ], ($leftLegMaterial)=>$leftLegMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'rightLeg', true).withEntity('VolleyballShorts').attach(memoEval((self)=>[
            self.$rightLegMaterial
        ], ($rightLegMaterial)=>$rightLegMaterial)),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'drawstring', true).withEntity('VolleyballShorts').attach(memoEval((self)=>[
            self.$drawstringMaterialColor
        ], ($drawstringMaterialColor)=>({
            fileUrl: 'models/volleyball-shorts.glb',
            materialName: 'LacesMaterial',
            materialsToOverride: [
                'LacesMaterial'
            ],
            color: $drawstringMaterialColor
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'stitches', true).withEntity('VolleyballShorts').attach(memoEval((self)=>[
            self.$stitchesMaterialColor
        ], ($stitchesMaterialColor)=>({
            fileUrl: 'models/volleyball-shorts.glb',
            materialName: 'StitchesMaterial',
            materialsToOverride: [
                'StitchesMaterial'
            ],
            color: $stitchesMaterialColor
        })))
];

//# sourceMappingURL=volleyball-shorts.js.map